module.exports = __webpack_public_path__ + "img/1.f21a1a77.png";